<script>
import Endpoints from '../../../../../components/common/Endpoints';
import Common from '../../../../../components/common/Common';
import Request from '../../../../../components/common/Request';

export default {
    init: (payload) => {
        payload.domain = Endpoints.domain;
    },
    methods:{
        save: function(){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;
            let data = JSON.parse(JSON.stringify(this.data.item));
            
            Request.do(this, 'POST', Request.getDefaultHeader(this), data, `${Endpoints.systemUsers.approveByFleetDriver}`,
                (response)=>{//SUCCESS CALLBACK
                   
                    state.data._id = response.result._id;
                    state.valuekey += 1;
                    this.$emit('confirmation-return', 1);
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }
                        $('#toast').modal('show');
                    }
            });
        },

        reject: function(){
          
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;
            let data = JSON.parse(JSON.stringify(this.data.item));
            console.log(data.email);
            Request.do(this, 'POST', Request.getDefaultHeader(this), data, `${Endpoints.systemUsers.reject}`,
                (response)=>{//SUCCESS CALLBACK
                    state.data._id = response.result._id;
                    state.valuekey += 1;
                    location.reload();

                    this.$emit('confirmation-return', 2);

                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }
                        $('#toast').modal('show');
                    }
            });
        },
        confirmArchive: function(){
            this.titleToast = this.$t("string.msg.confirm");
            this.messageToast = this.$t("response.approve.trucker.confirmation");
            this.cancelText = this.$t("string.msg.cancel");
            this.yesText = this.$t("string.msg.yes");
            $('#confirmationModal').modal('show');
        },
       

        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
